import {
    CardDecorGraphicFour,
    CardDecorGraphicOne,
    CardDecorGraphicThree,
    CardDecorGraphicTwo,
    ThresholdGPA,
    ThresholdGTL
} from '../../assets/img';

export const StepperStepTitles = ['Choose Base Plan', 'Add Family Members', 'Choose Add-Ons', 'Confirm Your Purchase'];
export const StepperStepTitlesNoAddons = ['Choose Base Plan', 'Add Family Members', 'Confirm Your Purchase'];
export const SegmentStepperPageTitles = [
    'Policy_Plan_Selection_Page',
    'Add_Dependant_page',
    'Insurance_Benefits_page',
    'Purchase_summary_page'
];

export const ThresholdData = {
    GTL: {
        title: 'Safeguard your family’s future with the term life policy',
        image: ThresholdGTL
    },
    GPA: {
        title: 'Stay covered against unforeseen accidents with the personal accident policy',
        image: ThresholdGPA
    }
};

export const BasePlanCardIllustrations = [
    CardDecorGraphicOne,
    CardDecorGraphicTwo,
    CardDecorGraphicThree,
    CardDecorGraphicFour
];

export const FamilyMemberSortingPreference = {
    'self': 0,
    'spouse': 1,
    'partner': 1,
    'child': 2,
    'sibling': 3,
    'parent': 4,
    'parent-in-law': 5
};
